const familyIcon = {
  methods: {
    getFamilyIcon: function (family) {
      if (family === 'AUTOMOTIVE') {
        return 'mdi-car'
      } else {
        return 'mdi-home'
      }
    }
  }
}

export default familyIcon
